import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.PLATFORM_SET_PLATFORM_LIST]: (state, payload) => {
    state.platformList = payload.data.platformList

    const sortNumberList = payload.data.platformList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  }
}

export default Mutations
